import { useEffect, useState } from "react";
import { PersonFill } from "react-bootstrap-icons";
import NotificationBell from "./NotificationBell";
import { Badge, Dropdown } from "react-bootstrap";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const TopNavbar = ({
  navbarTitle = "User",
  isAdmin,
  isTL,
  user,
  goToRequest,
  setActiveSection,
  fetchRules,
  isMobile,
  toggleSidebar,
  sidebarOpen,
}) => {
  const [rules, setRules] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/rule-book`)
      .then((res) => {
        setRules(
          res.data.map((r) => ({
            ...r,
            ac_employee: r.ac_employee?.split(",").map((id) => id.trim()) || [],
          }))
        );
      })
      .catch(() => setRules([]));
  }, [fetchRules]);

  const hasUnacknowledged = rules.some(
    (rule) => !rule.ac_employee?.includes(user?.name)
  );

  const handleProfileClick = () => setActiveSection?.("profileUpdate");
  const handleRuleBookClick = () => setActiveSection?.("ruleBook");

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #e8eaed",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        padding: "0 1.25rem",
        height: "56px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
      }}
    >
      {/* Left: hamburger (mobile only) + name */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0, flex: 1, overflow: "hidden" }}>
        {/* Hamburger: only on mobile when sidebar is closed (desktop uses sidebar's own hamburger) */}
        {isMobile && !sidebarOpen && (
          <button
            onClick={toggleSidebar}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "4px 6px",
              borderRadius: "6px",
              color: "#475569",
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
            }}
            aria-label="Toggle menu"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        )}

        {/* Vertical bar + name */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}>
          <span
            style={{
              width: "3px",
              height: "22px",
              backgroundColor: "#0d6efd",
              borderRadius: "2px",
              flexShrink: 0,
            }}
          />
          <span
            style={{
              color: "#1e293b",
              fontWeight: 600,
              fontSize: isMobile ? "0.9rem" : "1rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={user?.name ? `${navbarTitle} : Welcome, ${user.name}` : navbarTitle}
          >
            {navbarTitle}
            {user?.name && (
              <>
                <span style={{ fontWeight: 400, color: "#475569", margin: "0 6px" }}>:</span>
                <span style={{ fontWeight: 400, color: "#475569" }}>Welcome, </span>
                <span style={{ fontWeight: 600, color: "#1e293b" }}>{user.name}</span>
              </>
            )}
          </span>
        </div>
      </div>

      {/* Right: bell + profile */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          flexShrink: 0,
          paddingTop: "6px",   /* room for bell badge */
        }}
      >
        {(isAdmin || isTL) && (
          <NotificationBell user={user} onSelect={goToRequest} />
        )}

        <Dropdown align="end">
          <Dropdown.Toggle
            className="border-0 p-0"
            style={{
              background: "none",
              boxShadow: "none",
              lineHeight: 1,
            }}
          >
            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#0d6efd",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <PersonFill size={20} color="#fff" />
              {hasUnacknowledged && (
                <Badge
                  bg="danger"
                  pill
                  style={{
                    position: "absolute",
                    top: "-2px",
                    right: "-2px",
                    fontSize: "8px",
                    padding: "2px 4px",
                    border: "1.5px solid white",
                  }}
                >
                  •
                </Badge>
              )}
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={handleProfileClick}>Profile</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleRuleBookClick}>
              <div className="d-flex align-items-center justify-content-between">
                <span>Rule Book</span>
                {hasUnacknowledged && (
                  <Badge bg="danger" pill className="ms-2" style={{ fontSize: "10px" }}>
                    New
                  </Badge>
                )}
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
};

export default TopNavbar;
